import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SetupBedData } from '@models/app/helpers.model';
import { BedStatusEntity } from '@models/bed/bed-status.model';
import { BedEntity, BedPrivacyMode, UpdateBedProperty } from '@models/bed/bed.model';
import { SiqPopupHelper } from '@shared/utils/helpers/siq-popup.helper';
import { catchError, map, Observable, throwError } from 'rxjs';
import { EnvironmentsService } from './environments.service';
import { MixpanelService } from './mixpanel.service';
import { SiqApiService } from './siq-api.service';
import { SplashScreenService } from './splash-screen.service';

@Injectable({
  providedIn: 'root'
})
export class BedService extends SiqApiService {

  constructor(
    httpClient: HttpClient,
    environmentService: EnvironmentsService,
    mixpanelService: MixpanelService,
    siqPopupHelper: SiqPopupHelper,
    splashScreenService: SplashScreenService) {
    super(httpClient, environmentService, mixpanelService, siqPopupHelper, splashScreenService);
  }

  getBeds(): Observable<BedEntity> {
    return this.makeSiqRequest<BedEntity, object>('bed', 'siq', {}, 'GET', false).pipe(
      map((response: BedEntity | HttpErrorResponse) => {
        if (response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  getBedStatus(): Observable<BedStatusEntity> {
    return this.makeSiqRequest<BedStatusEntity, object>('bed/familyStatus/', 'siq', {}, 'GET', false).pipe(
      map((response: BedStatusEntity | HttpErrorResponse) => {
        if (response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  updateBed(bedId: string, data: UpdateBedProperty | SetupBedData): Observable<object> {
    return this.makeSiqRequest<object, UpdateBedProperty | SetupBedData>(`bed/${bedId}`, 'siq', data, 'PUT', false).pipe(
      map((response: object | HttpErrorResponse) => {
        if (response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  baselineBed(sleeperId: string): Observable<object> {
    return this.makeSiqRequest<object, object>(`sleeper/${sleeperId}/calibrate`, 'siq', {}, 'PUT', false).pipe(
      map((response: object | HttpErrorResponse) => {
        if (response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  getBedPauseMode(bedId: string): Observable<BedPrivacyMode> {
    return this.makeSiqRequest<BedPrivacyMode, object>(`bed/${bedId}/pauseMode`, 'siq', {}, 'GET', false).pipe(
      map((response: BedPrivacyMode | HttpErrorResponse) => {
        if (response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }

  setBedPauseMode(bedId: string, pauseMode: string): Observable<BedPrivacyMode> {
    return this.makeSiqRequest<BedPrivacyMode, object>(`bed/${bedId}/pauseMode?mode=${pauseMode}`, 'siq', {}, 'PUT', false).pipe(
      map((response: BedPrivacyMode | HttpErrorResponse) => {
        if (response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }
}
